import ActionPlanTask from './ActionPlanTask.model'
import Location from './Location.model'
import User from './User.model'
import { date } from 'quasar'

class ActionPlan {
  constructor (_actionPlan) {
    if (typeof _actionPlan !== 'undefined') {
      this.id = _actionPlan.id ? _actionPlan.id : null
      this.name = _actionPlan.name ? _actionPlan.name : null
      this.description = _actionPlan.description ? _actionPlan.description : null
      this.location_id = _actionPlan.location_id ? _actionPlan.location_id : null
      this.location_data = _actionPlan.location_data ? _actionPlan.location_data : null
      this.role_id = _actionPlan.role_id ? _actionPlan.role_id : null
      this.assigned_to = _actionPlan.assigned_to_data ? _actionPlan.assigned_to_data.full_name : null
      this.assigned_to_id = _actionPlan.assigned_to ? _actionPlan.assigned_to : null
      this.created_by = _actionPlan.created_by ? _actionPlan.created_by : null
      this.occurrence_id = _actionPlan.occurrence_id ? _actionPlan.occurrence_id : null
      this.item_id = _actionPlan.item_id ? _actionPlan.item_id : null
      this.priority = _actionPlan.priority ? _actionPlan.priority : 1
      this.verified = _actionPlan.verified ? _actionPlan.verified : 0
      this.notify = _actionPlan.notify ? _actionPlan.notify : []
      this.notify_push = _actionPlan.notify_push ? _actionPlan.notify_push : []
      this.tasks = _actionPlan.tasks
        ? _actionPlan.tasks.map(task => {
          return new ActionPlanTask(task)
        })
        : []
      this.location = _actionPlan.location ? new Location(_actionPlan.location) : {}
      this.creator = _actionPlan.creator ? new User(_actionPlan.creator) : {}
      this.start_date_local = _actionPlan.start_date_local ? _actionPlan.start_date_local : date.formatDate(Date.now(), 'YYYY-MM-DD HH:mm:ss')
      this.end_date_local = _actionPlan.end_date_local ? _actionPlan.end_date_local : null
      this.signatures = _actionPlan.signatures ? _actionPlan.signatures : []
      this.tag = _actionPlan.tag ? _actionPlan.tag : null
      this.progressState = _actionPlan.progressState ? _actionPlan.progressState : 0
      this.audited_user = _actionPlan.audited_user ? _actionPlan.audited_user : null
    } else {
      this.id = null
      this.name = null
      this.description = null
      this.location_id = null
      this.created_by = null
      this.occurrence_id = null
      this.item_id = null
      this.priority = 1
      this.verified = 0
      this.notify = []
      this.notify_push = []
      this.start_date_local = date.formatDate(Date.now(), 'YYYY-MM-DD HH:mm:ss')
      this.end_date_local = null
      this.tasks = []
      this.signatures = []
      this.tag = null
      this.status = 0
      this.audited_user = null
    }
  }

  get isExpired () {
    const now = new Date()
    const expired = now > this.end_date_local
    return expired
  }

  addTask () {
    const task = new ActionPlanTask({
      action_plan_id: this.id
    })
    this.tasks.push(task)
  }

  progress (roles, is_admin) {
    const tasks = this.tasks
    if (tasks.length > 0) {
      let total = 0

      if (tasks[0].role_id && is_admin) {
        const tasks_by_role = tasks.filter(task => {
          return roles.indexOf(task.role_id) > -1
        })

        if (tasks_by_role.length > 0) {
          tasks_by_role.forEach(task => {
            total = task.value ? total + 1 : total
          })
          return parseInt((total / tasks_by_role.length * 100))
        }
      }

      tasks.forEach(task => {
        total = task.value ? total + 1 : total
      })

      return parseInt((total / tasks.length * 100))
    }
    return 0
  }
}

export default ActionPlan
